import { getRequest } from "../../utils/request";
const url = 'api'

export const getCountAPI = data => getRequest(`/${url}/collection/dashboardCount`, data)

export const getAllIpInfoAPI = ({ current, pageSize }) => getRequest(`/${url}/collection/getAllIpInfo/${current}/${pageSize}`)

export const getUserInfoAPI = ({ current, pageSize }) => getRequest(`/${url}/collection/getAllFormData/${current}/${pageSize}`)
